module.exports = __webpack_public_path__ + "vg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/vg.svg
// module id = 1134
// module chunks = 0